import {
  Component,
  ChangeDetectorRef,
  DestroyRef,
  OnInit,
  ViewEncapsulation,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { StoreUserService } from '@app/core/state/store-user.service';
import {
  DatabaseCacheService,
  Breadcrumb,
} from "../../../data/cache/database-cache.service";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { ExpertDialogInnerComponent } from "./expert-dialog-inner/expert-dialog-inner.component";
import { EXPERT_DIALOG_I18N } from "./expert-dialog.i18n";

@Component({
  selector: "app-expert-dialog",
  templateUrl: "./expert-dialog.component.html",
  styleUrls: ["./expert-dialog.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [
    ...SHARED_IMPORTS,
    ExpertDialogInnerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertDialogComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly storeUser = inject(StoreUserService);
  private readonly databaseCashe = inject(DatabaseCacheService);
  private readonly cdr = inject(ChangeDetectorRef);

  protected readonly i18n = EXPERT_DIALOG_I18N;
  toolbarTitle = EXPERT_DIALOG_I18N.breadcrumb.contactBook;

  breadcrumbs: Breadcrumb[] = [];

  ngOnInit() {
    this.databaseCashe.parametersUpdated
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        try {
          // Sectionの選択と関連データの更新が終了したので、データベースキャッシュの必要なデータをローカル変数に読み込む
          const selectedSection = this.databaseCashe.getSelectedSection();

          if (selectedSection != null) {
            this.breadcrumbs = [
              {
                label: "",
                icon: "home",
                link: ["/home", selectedSection.sectionId],
              },
              {
                label: this.i18n.breadcrumb.userList,
                icon: "",
                link: ["/home", selectedSection.sectionId, "users"],
              },
              { label: this.i18n.breadcrumb.contactBook },
            ];
            this.cdr.markForCheck();
          }
        } catch (error) {
          console.error(
            `[${ExpertDialogComponent.name}] catch error in callback / error=${error}`,
          );
        }
      });
  }
}
